var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7969 2.91145C12.9317 2.77745 13.0053 2.59368 13 2.40364C13.0053 2.21359 12.9317 2.02982 12.7969 1.89583L11.1044 0.203388C10.9704 0.0685186 10.7867 -0.00498941 10.5966 0.000263393C10.4066 -0.00498941 10.2228 0.0685186 10.0888 0.203388L8.7685 1.5237L11.4766 4.23176L12.7969 2.91145ZM0 10.2922V13.0003H2.70806L10.6974 5.01095L7.98931 2.30208L0 10.2922Z",
    fill: "#718193"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.3594c9d413a34860411de9b41cc2ffde.svg";
export { ForwardRef as ReactComponent };